var o={randomUUID:"undefined"!=typeof crypto&&crypto.randomUUID&&crypto.randomUUID.bind(crypto)};export{o as default};
//# sourceMappingURL=native.js.map
